var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.752,
    x2: 324.752,
    y1: 56,
    y2: 337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d3326",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3326"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.752,
    x2: 242.752,
    xlinkHref: "#lg1",
    y1: 484,
    y2: 504.224
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.455,
    x2: 305.205,
    xlinkHref: "#lg1",
    y1: 43.966,
    y2: 15.883
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.708,
    x2: 280.708,
    xlinkHref: "#lg1",
    y1: 387.232,
    y2: 287.232
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.297,
    x2: 243.297,
    xlinkHref: "#lg2",
    y1: 197.874,
    y2: 329.052
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.297,
    x2: 243.297,
    xlinkHref: "#lg3",
    y1: 401.766,
    y2: 486.174
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.455,
    x2: 282.455,
    xlinkHref: "#lg2",
    y1: 424.424,
    y2: 453.26
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.596,
    x2: 241.096,
    xlinkHref: "#lg3",
    y1: 159.737,
    y2: -69.263
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.752,
    x2: 242.752,
    y1: 25.001,
    y2: 70.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.752,
    x2: 242.752,
    xlinkHref: "#lg4",
    y1: 21.25,
    y2: 53.016
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse",
    x1: 242.752,
    x2: 242.752,
    xlinkHref: "#lg4",
    y1: 27.125,
    y2: 43.008
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.252,
    x2: 207.252,
    xlinkHref: "#lg4",
    y1: 57.25,
    y2: 71.5
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.252,
    x2: 278.252,
    xlinkHref: "#lg4",
    y1: 57.25,
    y2: 71.5
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deecf1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.614,
    x2: 151.826,
    xlinkHref: "#lg5",
    y1: 138.645,
    y2: 117.857
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.786,
    x2: 162.788,
    xlinkHref: "#lg6",
    y1: 100.652,
    y2: 128.654
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.614,
    x2: 151.826,
    xlinkHref: "#lg5",
    y1: 216.645,
    y2: 195.857
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.786,
    x2: 162.788,
    xlinkHref: "#lg6",
    y1: 178.652,
    y2: 206.654
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.614,
    x2: 151.826,
    xlinkHref: "#lg5",
    y1: 294.645,
    y2: 273.857
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.786,
    x2: 162.788,
    xlinkHref: "#lg6",
    y1: 256.652,
    y2: 284.654
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m410.154 510h-334.805c-14.029 0-25.402-11.373-25.402-25.402v-459.196c0-14.029 11.373-25.402 25.402-25.402h334.805c14.029 0 25.402 11.373 25.402 25.402v459.195c.001 14.03-11.372 25.403-25.402 25.403z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.947 375.124v109.473c0 14.03 11.373 25.403 25.402 25.403h334.805c14.029 0 25.402-11.373 25.402-25.402v-109.474z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m300.252 20.167 9.458 9.458h4.792l5.687 5.688h-19.937z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.557 484.598v-412.305l-28.072-28.072c-2.895-5.252-8.481-8.813-14.902-8.813h-295.073c-9.393 0-17.008 7.615-17.008 17.008v411.485c0 8.922 4.479 16.795 11.308 21.504l24.595 24.595h293.749c14.03 0 25.403-11.373 25.403-25.402z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m337.436 488.257h-232.578c-14.418 0-26.106-11.688-26.106-26.106v-411.484c0-9.393 7.615-17.008 17.008-17.008h295.073c9.393 0 17.008 7.615 17.008 17.008v367.184c.001 38.884-31.521 70.406-70.405 70.406z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.752 366.958v95.193c0 14.418 11.688 26.106 26.106 26.106h232.578c38.884 0 70.406-31.522 70.406-70.406v-50.893z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.963 405.333v56.818c0 14.418-11.688 26.106-26.106 26.106h284.789c38.884 0 70.406-31.522 70.406-70.406v-12.518c0-9.393-7.615-17.008-17.008-17.008h-295.072c-9.394 0-17.009 7.615-17.009 17.008z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m167.752 56.554c0 4.939 2.684 9.253 6.663 11.591l233.427 233.427v-176.927l-90.987-90.987h-148.206c-.571 1.49-.897 3.101-.897 4.789z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.305 70h-123.106c-7.415 0-13.447-6.032-13.447-13.447v-18.105c0-7.415 6.032-13.447 13.447-13.447h123.106c7.415 0 13.447 6.032 13.447 13.447v18.106c0 7.414-6.032 13.446-13.447 13.446zm-123.106-34c-1.349 0-2.447 1.098-2.447 2.447v18.106c0 1.349 1.098 2.447 2.447 2.447h123.106c1.35 0 2.447-1.098 2.447-2.447v-18.105c0-1.35-1.098-2.447-2.447-2.447h-123.106z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.335 49h-103.166c-3.912 0-7.083-3.171-7.083-7.083v-17.834c0-3.912 3.171-7.083 7.083-7.083h103.167c3.912 0 7.083 3.171 7.083 7.083v17.833c0 3.913-3.172 7.084-7.084 7.084z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.365 25h-81.227c-2.423 0-4.387 1.964-4.387 4.387v7.227c0 2.423 1.964 4.387 4.387 4.387h81.227c2.423 0 4.387-1.964 4.387-4.387v-7.227c0-2.423-1.964-4.387-4.387-4.387z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m215.252 71.5h-16c-2.554 0-4.625-2.071-4.625-4.625v-5c0-2.554 2.071-4.625 4.625-4.625h16c2.554 0 4.625 2.071 4.625 4.625v5c0 2.554-2.071 4.625-4.625 4.625z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.252 71.5h-16c-2.554 0-4.625-2.071-4.625-4.625v-5c0-2.554 2.071-4.625 4.625-4.625h16c2.554 0 4.625 2.071 4.625 4.625v5c0 2.554-2.071 4.625-4.625 4.625z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.009 146h-22c-9.512 0-17.25-7.738-17.25-17.25v-22c0-9.512 7.738-17.25 17.25-17.25h22c9.512 0 17.25 7.738 17.25 17.25v22c0 9.512-7.738 17.25-17.25 17.25zm-22-45.5c-3.446 0-6.25 2.804-6.25 6.25v22c0 3.446 2.804 6.25 6.25 6.25h22c3.446 0 6.25-2.804 6.25-6.25v-22c0-3.446-2.804-6.25-6.25-6.25z",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.249 133.84-45.33 45.33-61.01-60.79c-2.53-2.54-2.53-6.33 0-8.86 2.54-2.54 6.65-2.54 9.18 0l14.12 14.12c1.67 1.66 4.37 1.66 6.04 0l28.81-28.81c2.53-2.54 6.64-2.54 9.18 0z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.913 94.18c-2.535-2.535-6.646-2.535-9.181 0l-28.806 28.806c-1.669 1.669-4.374 1.669-6.043 0l-14.116-14.116c-2.535-2.535-6.646-2.535-9.181 0-2.535 2.535-2.535 6.646 0 9.181l17.903 17.903c4.648 4.648 12.183 4.648 16.831 0l32.593-32.593c2.535-2.535 2.535-6.645 0-9.181z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.009 224h-22c-9.512 0-17.25-7.738-17.25-17.25v-22c0-9.512 7.738-17.25 17.25-17.25h22c9.512 0 17.25 7.738 17.25 17.25v22c0 9.512-7.738 17.25-17.25 17.25zm-22-45.5c-3.446 0-6.25 2.804-6.25 6.25v22c0 3.446 2.804 6.25 6.25 6.25h22c3.446 0 6.25-2.804 6.25-6.25v-22c0-3.446-2.804-6.25-6.25-6.25z",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.249 211.84-45.33 45.33-61.01-60.79c-2.53-2.54-2.53-6.33 0-8.86 2.54-2.54 6.65-2.54 9.18 0l14.12 14.12c1.67 1.66 4.37 1.66 6.04 0l28.81-28.81c2.53-2.54 6.64-2.54 9.18 0z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.913 172.18c-2.535-2.535-6.646-2.535-9.181 0l-28.806 28.806c-1.669 1.669-4.374 1.669-6.043 0l-14.116-14.116c-2.535-2.535-6.646-2.535-9.181 0-2.535 2.535-2.535 6.646 0 9.181l17.903 17.903c4.648 4.648 12.183 4.648 16.831 0l32.593-32.593c2.535-2.535 2.535-6.645 0-9.181z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.009 302h-22c-9.512 0-17.25-7.738-17.25-17.25v-22c0-9.512 7.738-17.25 17.25-17.25h22c9.512 0 17.25 7.738 17.25 17.25v22c0 9.512-7.738 17.25-17.25 17.25zm-22-45.5c-3.446 0-6.25 2.804-6.25 6.25v22c0 3.446 2.804 6.25 6.25 6.25h22c3.446 0 6.25-2.804 6.25-6.25v-22c0-3.446-2.804-6.25-6.25-6.25z",
    fill: "#3e5959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.249 289.84-45.33 45.33-61.01-60.79c-2.53-2.54-2.53-6.33 0-8.86 2.54-2.54 6.65-2.54 9.18 0l14.12 14.12c1.67 1.66 4.37 1.66 6.04 0l28.81-28.81c2.53-2.54 6.64-2.54 9.18 0z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.913 250.18c-2.535-2.535-6.646-2.535-9.181 0l-28.806 28.806c-1.669 1.669-4.374 1.669-6.043 0l-14.116-14.116c-2.535-2.535-6.646-2.535-9.181 0-2.535 2.535-2.535 6.646 0 9.181l17.903 17.903c4.648 4.648 12.183 4.648 16.831 0l32.593-32.593c2.535-2.535 2.535-6.645 0-9.181z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.009 380h-22c-9.512 0-17.25-7.738-17.25-17.25v-22c0-9.512 7.738-17.25 17.25-17.25h22c9.512 0 17.25 7.738 17.25 17.25v22c0 9.512-7.738 17.25-17.25 17.25zm-22-45.5c-3.446 0-6.25 2.804-6.25 6.25v22c0 3.446 2.804 6.25 6.25 6.25h22c3.446 0 6.25-2.804 6.25-6.25v-22c0-3.446-2.804-6.25-6.25-6.25z",
    fill: "#3e5959"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.092 113.03h-179.953c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h179.954c2.59 0 4.69 2.1 4.69 4.69v6.395c-.001 2.59-2.1 4.69-4.691 4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.309 139.465h-138.17c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h138.17c2.59 0 4.69 2.1 4.69 4.69v6.395c0 2.59-2.1 4.69-4.69 4.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.092 190.362h-179.953c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h179.954c2.59 0 4.69 2.1 4.69 4.69v6.395c-.001 2.59-2.1 4.69-4.691 4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.309 216.797h-138.17c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h138.17c2.59 0 4.69 2.1 4.69 4.69v6.395c0 2.59-2.1 4.69-4.69 4.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.092 268.695h-179.953c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h179.954c2.59 0 4.69 2.1 4.69 4.69v6.395c-.001 2.59-2.1 4.69-4.691 4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.309 295.129h-138.17c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h138.17c2.59 0 4.69 2.1 4.69 4.69v6.395c0 2.591-2.1 4.69-4.69 4.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.092 345.026h-179.953c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h179.954c2.59 0 4.69 2.1 4.69 4.69v6.395c-.001 2.591-2.1 4.69-4.691 4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.309 371.461h-138.17c-2.59 0-4.69-2.1-4.69-4.69v-6.395c0-2.59 2.1-4.69 4.69-4.69h138.17c2.59 0 4.69 2.1 4.69 4.69v6.395c0 2.59-2.1 4.69-4.69 4.69z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormConnectionIcon);
export default __webpack_public_path__ + "static/media/form-connection-icon.fe371a58249142d9c7d18f92525eb81e.svg";
export { ForwardRef as ReactComponent };